import { action } from 'easy-peasy';
import { IActionAddPatientNotificationRule } from '../types';

const addNotificationRule: IActionAddPatientNotificationRule = action((state, payload) => {
  state.items = [...state.items, payload];
});

export default addNotificationRule;
